import Flex from 'components/priority/Flex/Flex'
import { CaseFormSection } from 'components/dashboard/CaseDetails'
import { SidebarMenuSaveSection } from 'components/editor/InsertMenu/SidebarMenuSaveSection'
import { M3FamilyAppreciationMessage } from 'components/dashboard/CaseDetails/M3FamilyAppreciationMessage'
import { useIsM3Order } from '@/hooks/utility/useIsM3Order'

export const ServiceInfoMenu = ({ saveCase }) => {
  // The family appreciation message is an M3-only case field.
  const isM3Order = useIsM3Order()

  return (
    <>
      <Flex full center padding="8px 8px 100px 8px" gap="8px" column>
        <CaseFormSection formSection="serviceInfo" sidebar={true} />
        <CaseFormSection formSection="pallBearersSocieties" sidebar={true} />
        <CaseFormSection formSection="intermentInfo" sidebar={true} />
        {isM3Order && (
          <M3FamilyAppreciationMessage margin="0 24px 24px 24px" width="auto" />
        )}
      </Flex>
      <SidebarMenuSaveSection saveCase={saveCase} />
    </>
  )
}

export default ServiceInfoMenu
